import { Maybe } from "true-myth";

import { AccountActionTypes, AccountTypeKeys } from "actions/account";

import { ISalesForecast } from "types/account";
import { IAccountState } from "types/reducers";
import { RequestStatus } from "types/requests";

const initialState: IAccountState = {
  dayParts: [],
  locations: [],
  permalink: Maybe.nothing<string>(),
  salesForecast: Maybe.nothing<ISalesForecast>(),
  requestStatuses: {
    salesForecastGet: RequestStatus.NOT_STARTED,
    dayPartsPost: RequestStatus.NOT_STARTED,
    locationsGet: RequestStatus.NOT_STARTED,
  },
};

export default function account(
  state: IAccountState = initialState,
  action: AccountActionTypes
) {
  switch (action.type) {
    case AccountTypeKeys.RECEIVE_SALES_FORECAST: {
      return {
        ...state,
        salesForecast: Maybe.of(action.salesForecast),
      };
    }

    case AccountTypeKeys.RECEIVE_LOCATIONS: {
      return {
        ...state,
        locations: action.locations,
        permalink: Maybe.of(action.permalink),
      };
    }

    case AccountTypeKeys.RECEIVE_DAY_PARTS: {
      return {
        ...state,
        dayParts: action.dayParts,
      };
    }

    case AccountTypeKeys.SET_REQUEST_STATUS: {
      return {
        ...state,
        requestStatuses: {
          ...state.requestStatuses,
          [action.apiRequest]: action.status,
        },
      };
    }

    default: {
      return state;
    }
  }
}
